import React from 'react';
import { Link } from 'react-router-dom';
import './header.css'

const Header = () => {
    const menu = <>
        <li><Link to='/'>Home</Link></li>
        <li><a href='#projects'>Projects</a></li>
        <li><a href='#contact'>Contact me</a></li>
        <li><Link to='/blog'>Blogs</Link></li>
        <li><a href='#about'>about</a></li>
    </>

    return (
        <div className='lg:mx-40 lg:mt-5'>
            <div className="bg-regal-blue lg:bg-inherit navbar">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 lg:text-black text-slate-200" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="p-2 mt-3 shadow lg:hidden menu menu-compact dropdown-content rounded-box w-52 smmenu">
                            {
                                menu
                            }
                        </ul>
                        <Link className="ml-5 text-2xl font-bold normal-case lg:text-3xl lg:text-slate-700 text-slate-200">M A R U F</Link>
                    </div>


                </div>
                <div className="hidden navbar-end lg:flex">

                    <ul className="font-semibold menu menu-horizontal lgmenu menu-compact">
                        {
                            menu
                        }
                    </ul>

                </div>

            </div>
        </div>
    );
};

export default Header;